module.exports = __webpack_public_path__ + "media/assets/icons/left-arrow-blue-6f17ab1013e6696abb983cf294f1a65c.svg";